import React from 'react';
import {
  faShieldCheck,
  faLightbulbOn,
  faChartLineUp,
  faHandsHoldingCircle,
  faPersonPinball,
} from '@fortawesome/pro-light-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import ValueCard from './ValueCard';
import DefaultLayout from '../../layouts/DefaultLayout';
import Container from '../../components/ui/Container';
import Panel from '../../components/ui/Panel';
import Breadcrumbs from '../../components/Breadcrumbs';

const breadcrumbLinks = [
  { name: 'Home', linkTo: '/' },
  { name: 'Over ons', linkTo: '/home/overons' },
  { name: 'Kernwaarden', linkTo: '/home/kernwaarden' },
];

const ourValues = [
  {
    icon: faShieldCheck,
    title: '1. Betrouwbaar',
    description:
      'Vertrouwen is de basis van goede samenwerking. We durven in alle opzichten open en eerlijk te zijn door onze gevoelens en meningen ongeveinsd met elkaar te delen.',
  },
  {
    icon: faLightbulbOn,
    title: '2. Ondernemend',
    description:
      'We hebben ondernemerschap hoog in het vaandel staan. Daarom zijn we ooit gestart met Advieskeuze. We wachten niet af en nemen zelf het initiatief om zaken in gang te zetten en zijn we te allen tijde op zoek naar innovatieve oplossingen en samenwerkingen.',
  },
  {
    icon: faChartLineUp,
    title: '3. Resultaatgericht',
    description:
      'Wij willen op professionele wijze samenwerken met de beste organisaties in Nederland. Dat doen we onder andere door te bouwen aan een goede relatie, het delen van onze ervaringen en uiteraard een maximale inzet te tonen om te gaan voor het hoogst haalbare doel.',
  },
  {
    icon: faHandsHoldingCircle,
    title: '4. Idealistisch',
    description:
      'Idealisme zit in ons bloed. We geloven in een ‘betere wereld’ waarbij diensten worden aangeboden waar je écht iets aan hebt. Daar hoort ook bij dat wij slechte diensten aan de kaak zullen stellen en proberen we om de dialoog aan te gaan.',
  },
  {
    icon: faPersonPinball,
    title: '5. Plezier',
    description:
      'Plezier is voor ons een heel belangrijk cultuurelement. Het is de basis voor een stuk animo, voldoening en passie. Met veel lol en enthousiasme wordt werken een liefhebberij. Dit genoegen delen we graag met jou en onze businesspartners.',
  },
];

export const AboutPage: React.FC = () => (
  <DefaultLayout breadcrumbs={<Breadcrumbs links={breadcrumbLinks} />}>
    <Container state="defaultLayoutFirst">
      <div className="flex flex-col md:flex-row gap-5">
        <div className="w-full md:w-[calc(50%-5px)] mb-5">
          <Panel className="h-full">
            <h1 className="font-bold text-blue-700 font-avantgarde text-[18px] md:text-[26px] leading-[27px] md:leading-[39px] mb-[16px]">
              Missie
            </h1>
            <p className="font-normal text-stone-800 font-body text-[14px] md:text-[16px] leading-[23.1px] md:leading-[26.4px] whitespace-pre-wrap">
              Advieskeuze is een platform dat de consument helpt bij het vinden
              van de juiste dienstverlener. Het kiezen voor een dienstverlener is
              namelijk lang niet altijd eenvoudig omdat per persoon verschillend is
              waar je hulp of advies bij nodig hebt. Advieskeuze verzamelt zoveel
              mogelijk relevante data: het platform toont betrouwbare informatie
              over dienstverleners en maakt klantbeleving inzichtelijk door middel
              van reviews. Advieskeuze streeft ernaar alle dienstverleners te
              activeren om met het platform te werken en in co-creatie met andere
              (markt)partijen een zo groot mogelijk consumentenbereik te creëren.
            </p>
          </Panel>
        </div>
        <div className="w-full md:w-[calc(50%-5px)] mb-5">
          <Panel className="h-full">
            <h2 className="font-bold text-blue-700 font-avantgarde text-[18px] md:text-[26px] leading-[27px] md:leading-[39px] mb-[16px]">
              Visie
            </h2>
            <p className="font-normal text-stone-800 font-body text-[14px] md:text-[16px] leading-[23.1px] md:leading-[26.4px] whitespace-pre-wrap">
              Advieskeuze streeft ernaar het platform te zijn waarop objectieve
              advieskwaliteit over dienstverlening in Nederland zichtbaar is voor de
              consument, zodat iedere consument met vertrouwen een bewuste keuze kan
              maken voor de dienstverlener die het best bij hem past.
            </p>
          </Panel>
        </div>
      </div>

      <Panel position="last">
        <h2 className="font-bold text-blue-700 font-avantgarde text-[18px] md:text-[26px] leading-[27px] md:leading-[39px] mb-[16px]">
          Kernwaarden Advieskeuze
        </h2>
        <p className="md:mb-[48px] mb-[42px] font-light text-blue-600 font-body text-[16px] md:text-[20px] leading-[26.4px] md:leading-[33px]">
          Onze eigen filosofie baseren we op onze vijf kernwaarden.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-[26px] md:gap-[50px]">
          {ourValues.map((data, index) => (
            <div key={data.title}>
              <ValueCard
                icon={data.icon as IconProp}
                description={data.description}
                title={data.title}
              />
              {index !== 4 && (
                <div className="w-full h-[2px] bg-stone-100 block md:hidden"></div>
              )}
            </div>
          ))}
        </div>
      </Panel>
    </Container>
  </DefaultLayout>
);
